import { Component } from '@angular/core';

@Component({
  selector: 'rm-basic-header',
  templateUrl: './basic-header.component.html',
  styleUrls: ['./basic-header.component.css']
})
export class BasicHeaderComponent{
}
